import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { getEnv } from "./environment";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import axios from "axios";

const env = getEnv();
console.log("Setting Axios Env: ", env);
console.log("Axios URL: ", env.url);
axios.defaults.baseURL = env.url;

export const pca = new PublicClientApplication({
  auth: {
    clientId: env.auth_client_id,
    authority: env.authority,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
});

//Default to using the first account if no account is active on page load
if (!pca.getActiveAccount() && pca.getAllAccounts().length > 0) {
  pca.setActiveAccount(pca.getAllAccounts()[0]);
}

// Update account state if a user signs in from another tab or window
pca.enableAccountStorageEvents();

pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    pca.setActiveAccount(account);
  }
});

// axios.interceptors.request.use(
//   async (config) => {
//     const accounts = pca.getAllAccounts();
//     if (accounts.length > 0) {
//       try {
//         const response = await pca.acquireTokenSilent({
//           account: accounts[0],
//           scopes: [env.auth_scope],
//         });
//         config.headers.Authorization = `Bearer ${response.accessToken}`;
//       } catch (error) {
//         console.error("Token acquisition failed", error);
//       }
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
console.log("pca: ", pca);
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App msalInstance={pca} />
  </React.StrictMode>
);
